// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1vCme","icon":"SortAdornment_icon__atR69","up":"SortAdornment_up__3N5RA","down":"SortAdornment_down__s0mJR","active":"SortAdornment_active__3RFY4"};